"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrosiveRain = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var CorrosiveRainDeferredAction_1 = require("../../deferredActions/CorrosiveRainDeferredAction");
var CorrosiveRain = (function () {
    function CorrosiveRain() {
        this.name = GlobalEventName_1.GlobalEventName.CORROSIVE_RAIN;
        this.description = 'Lose 2 floaters from a card or 10 M€. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.KELVINISTS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    CorrosiveRain.prototype.resolve = function (game, turmoil) {
        game.getPlayers().forEach(function (player) {
            player.drawCard(turmoil.getPlayerInfluence(player));
            game.defer(new CorrosiveRainDeferredAction_1.CorrosiveRainDeferredAction(player));
        });
    };
    return CorrosiveRain;
}());
exports.CorrosiveRain = CorrosiveRain;
//# sourceMappingURL=CorrosiveRain.js.map